import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeleteDiscordIntegrationMutation = createMutationHook(
  MembershipsCreatorApiClient.deleteDiscordIntegration,
  {
    mutationKey: ['deleteDiscordIntegration'],
  },
)
